module.exports = __webpack_public_path__ + "img/svg - left window.57855832.svg";